import { RedirectLoginOptions } from '@auth0/auth0-react';
import type { Location, To } from 'react-router-dom';
import { currentPageToReturnTo, signupParamsFromUrl } from '@grc/ui-utility';

// The invite email's params. Auth0 reads them on the login they start.
const INVITE_PARAMS = ['screen_hint', 'login_hint'];

// An invite link opens Auth0 Register with the invited email filled in, and after login
// Auth0ProviderWithRedirectCallback navigates back to appState.returnTo, the page the user was on.
export const loginOptions = (): RedirectLoginOptions => ({
  authorizationParams: signupParamsFromUrl(),
  appState: { returnTo: currentPageToReturnTo() }
});

// Where to send a signed-in user whose address still carries the invite params, or undefined
// when it carries none. A login through Auth0 comes back to returnTo, which never carries them,
// but a silent login (an Auth0 session already exists) does not leave the page, so the invited
// email would stay in the URL. The caller replaces the entry through the router, so the router's
// location (useSearchParams included) no longer has them either.
export const withoutInviteParams = ({
  pathname,
  search,
  hash
}: Pick<Location, 'pathname' | 'search' | 'hash'>): To | undefined => {
  const params = new URLSearchParams(search);
  if (!INVITE_PARAMS.some(name => params.has(name))) {
    return undefined;
  }
  INVITE_PARAMS.forEach(name => params.delete(name));
  const rest = params.toString();
  return { pathname, search: rest ? `?${rest}` : '', hash };
};
